// extracted by mini-css-extract-plugin
module.exports = {"root":"FieldCheckboxGroup_root__113EU","list":"FieldCheckboxGroup_list__1UhIH","twoColumns":"FieldCheckboxGroup_twoColumns__Eis84","item":"FieldCheckboxGroup_item__b_jJi"};